import React, { Component } from 'react';

import Calendar from './Calendar';
import Separator from '../shared/Separator';
import MonthHeader from './MonthHeader';

import { m } from '../../utils';
import './index.css';

class WeeklyCalendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      start: m().startOf('isoWeek'),
      end: m().endOf('isoWeek'),
    };
  }

  componentDidMount() {
    this.props.getDaysInWeek(m());
  }

  componentWillReceiveProps(nextProps) {
    const { week } = nextProps;
    this.setState({
      start: m(week[0]),
      end: m(week[6]),
    });

    if (this.props.token !== nextProps.token) {
      this.props.refetchBookings();
    }
  }

  // TODO: Refactor pls Jasper
  getNextWeek = () => {
    const { start, end } = this.state;
    this.setState(
      prevState => {
        this.tryChangeMonth(prevState.start, start.clone().add(1, 'week'));
        return { start: start.add(1, 'week'), end: end.add(1, 'week') };
      },
      () => this.props.getDaysInWeek(start)
    );
  };

  getPrevWeek = () => {
    const { start, end } = this.state;
    this.setState(
      prevState => {
        this.tryChangeMonth(prevState.start, start.clone().subtract(1, 'week'));
        return {
          start: start.subtract(1, 'week'),
          end: end.subtract(1, 'week'),
        };
      },
      () => this.props.getDaysInWeek(start)
    );
  };

  goToMonth = async month => {
    const button = await document.getElementById(month);
    button.click();
  };

  tryChangeMonth = (prevStart, nextStart) => {
    if (nextStart.isAfter(prevStart, 'month')) {
      this.goToMonth('next-month');
    }
    if (nextStart.isBefore(prevStart, 'month')) {
      this.goToMonth('prev-month');
    }
  };

  displayMonth = (start, end) => `${start.format('MMM D')} - ${end.format('MMM D')}`;

  render() {
    const {
      bookingDetail,
      bookings,
      cars,
      duration,
      isDoubleShift,
      loadAvailableShifts,
      selectedShifts,
      shifts,
      startTime,
      tier,
      toggleShiftList,
      upcomingShift,
      week,
      vehicleAvailability,
      loading,
      error,
    } = this.props;

    const { start, end } = this.state;

    return (
      <div>
        <Separator className="half-width" />

        <MonthHeader
          displayMonth={this.displayMonth(start, end)}
          getNextWeek={this.getNextWeek}
          getPrevWeek={this.getPrevWeek}
        />

        <Separator className="half-width" />
        <Calendar
          bookingDetail={bookingDetail}
          bookings={bookings}
          cars={cars}
          daysInWeek={week}
          duration={duration}
          isDoubleShift={
            isDoubleShift // isDashboard={isDashboard}
          }
          loadAvailableShifts={loadAvailableShifts}
          selectedShifts={selectedShifts}
          shifts={shifts}
          startTime={startTime}
          tier={tier}
          toggleShiftList={toggleShiftList}
          upcomingShift={upcomingShift}
          vehicleAvailability={vehicleAvailability}
          loading={loading}
          error={error}
        />
      </div>
    );
  }
}

export default WeeklyCalendar;



// WEBPACK FOOTER //
// ./src/components/WeeklyCalendar/index.js